module.exports = __webpack_public_path__ + "static/img/newspaper.21348ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anniversary/newspaper.png
// module id = Vc3N
// module chunks = 0